import { createComponent } from "@helpers/admin";
import BentoSectionComponent from "@template/blocks/BentoSection/component";

export const LegacyBento = createComponent({
  label: "Legacy Bento",
  component: () =>
    BentoSectionComponent({
      heading: "All the phone system features you need",
      subHeading:
        "From seamless CRM integrations and IVR Call menus, through to intelligent Call Queuing and Time of Day Routing, get the professional features you require to help your business thrive.",
      boxes: [
        {
          heading: "Desktop & Mobile Apps",
          subHeading:
            "Hassle-free calling on any device, from anywhere. Get started in 60 seconds with our softphone apps.",
          link: {
            text: "Learn more",
            title: "Learn more about our apps",
            href: "/app",
          },
          image: {
            src: "/legacy_images/image1.png",
            alt: "Image of a desktop and mobile phone",
          },
        },
        {
          heading: "Integrations",
          subHeading:
            "Easily combine our phone system with the tools you use the most.",
          image: {
            src: "/legacy_images/image2.png",
            alt: "Image of a various integrations with Yay.com",
          },
          cta: {
            text: "Discover all features",
            title: "Discover all features of our business phone system",
            href: "/voice/business-phone-system/",
          },
        },
        {
          heading: "Time of Day Routing",
          subHeading: "Professionally handle calls out of business hours.",
          image: {
            src: "/legacy_images/image3.png",
            alt: "Image of a week calendar",
          },
        },
        {
          heading: "IVR Call Menus",
          subHeading: "Enhance caller satisfaction via dynamic custom menus.",
          image: {
            src: "/legacy_images/image4.png",
            alt: "Diagram of call queue system",
          },
          flip: true,
        },
      ],
    }),
  fields: {},
});
